import { useContext } from "react";

import { SdkContext } from "../SdkProvider";

export const useSdk = () => useContext(SdkContext).sdk;
